import { useState } from "react";
import { ChevronDown } from "lucide-react";


const steps = [
  { day: "Today", title: "Free valuation, we do the research", desc: "Tell us the postcode and the number of bedrooms. We come back with an income estimate built from live comparables in your area, not a national average. No commitment." },
  { day: "Days 3 to 5", title: "We set everything up", desc: "Professional photography, listing copy, compliance checks, safety certificates and furnishing advice if you need it. You approve, we do the rest." },
  { day: "Day 7", title: "Live on 16+ platforms", desc: "Airbnb, Booking.com and fourteen others go live at once, with dynamic pricing running from the first night." },
  { day: "First booking", title: "Your first payout", desc: "Paid within 48 hours of your first check-in, and every booking after that." },
];

function currentMonthName() {
  return new Date().toLocaleDateString("en-GB", { month: "long" });
}

export default function ManchesterHowItWorks() {
  const month = currentMonthName();
  const [open, setOpen] = useState(0);

  return (
    <>
      {/* Full-width fee waiver callout — above Getting started */}
      <div style={{ background: "#112215", padding: "20px clamp(20px,5vw,80px)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "center", gap: 14, flexWrap: "wrap" }}>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "#CCF5AC", background: "rgba(204,245,172,0.15)", padding: "4px 10px", borderRadius: 100, whiteSpace: "nowrap" }}>
            This month
          </span>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, fontWeight: 600, color: "#fff", margin: 0, textAlign: "center" }}>
            Get in touch before the end of {month}. Your &pound;150 onboarding fee is waived
          </p>
        </div>
      </div>

      <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "0.85fr 1.15fr", gap: "clamp(40px,6vw,80px)", alignItems: "start" }} className="hiw-split">
            {/* Left: heading */}
            <div style={{ paddingTop: 4 }}>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>Getting started</p>
              <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px,4vw,42px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#112215", margin: "0 0 16px" }}>
                From first call to live in seven days
              </h2>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "#5C7268", lineHeight: 1.65, margin: 0 }}>
                A clear, predictable path from your first conversation to your first payout.
              </p>
            </div>

            {/* Right: accordion with numbered timeline */}
            <div style={{ display: "flex", flexDirection: "column" }}>
              {steps.map((step, i) => {
                const isOpen = open === i;
                const isLast = i === steps.length - 1;
                return (
                  <div key={i} style={{ display: "flex", gap: 18, cursor: "pointer" }} onClick={() => setOpen(open === i ? -1 : i)}>
                    {/* Number badge + dashed connector */}
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <div style={{
                        width: 38, height: 38, borderRadius: "50%",
                        background: isOpen ? "#CD533B" : "#E8E4D5",
                        color: isOpen ? "#fff" : "#8A9B92",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 14,
                        flexShrink: 0, zIndex: 1, transition: "background 0.2s, color 0.2s",
                      }}>{i + 1}</div>
                      {!isLast && (
                        <div style={{ width: 0, borderLeft: "2px dashed #D5D0BE", flex: 1, minHeight: 28 }} />
                      )}
                    </div>

                    {/* Content */}
                    <div
                      style={{ paddingBottom: isLast ? 0 : 24, flex: 1 }}
                    >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, paddingTop: 8 }}>
                        <div>
                          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: "#8A9B92", marginBottom: 3, marginTop: 0 }}>{step.day}</p>
                          <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 17, color: "#112215", margin: 0, letterSpacing: "-0.01em" }}>{step.title}</p>
                        </div>
                        <ChevronDown size={18} color={isOpen ? "#CD533B" : "#8A9B92"} style={{ transform: isOpen ? "rotate(180deg)" : "none", transition: "transform 0.2s", flexShrink: 0 }} />
                      </div>
                      {isOpen && (
                        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: "#5C7268", lineHeight: 1.65, margin: "10px 0 0" }}>{step.desc}</p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <style>{`
          @media (max-width: 768px) { .hiw-split { grid-template-columns: 1fr !important; gap: 32px !important; } }
        `}</style>
      </section>
    </>
  );
}